import { useAsertoApiWithAuth, v1Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useAccountClient() {
  const { tenantServiceUrl } = useConfig()
  return useAsertoApiWithAuth(v1Api(tenantServiceUrl))
}
